import { ErrorHandler, Injectable } from '@angular/core';
import { TrackJS } from 'trackjs';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: Error) {
    if (TrackJS.isInstalled()) {
      TrackJS.track(error);
    }
  }
}
